export const AU_STATES = ["WA", "NSW", "VIC", "QLD", "SA", "TAS", "ACT", "NT"];
export const TIMEZONES = ["Australia/Perth", "Australia/Darwin", "Australia/Adelaide", "Australia/Brisbane", "Australia/Sydney", "Australia/Melbourne", "Australia/Hobart"];
export const CURRENCIES = ["AUD", "NZD"];
export const DAYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

export function fmtDate(iso, tz) {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("en-AU", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: tz || undefined }).format(new Date(iso));
  } catch {
    return "—";
  }
}

export function fmtDateTime(iso, tz) {
  if (!iso) return "—";
  return new Intl.DateTimeFormat("en-AU", {
    day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: tz || undefined,
  }).format(new Date(iso));
}

export const fmtYmd = (ymd) => {
  if (!ymd) return "—";
  const [y, m, d] = ymd.split("-");
  return `${d}/${m}/${y}`;
};

export function fmtBytes(n) {
  if (!n) return "0 MB";
  const mb = n / (1024 * 1024);
  return mb < 0.1 ? `${(n / 1024).toFixed(1)} KB` : `${mb.toFixed(1)} MB`;
}

export const fmtMoney = (n, cur = "AUD") =>
  n == null ? "—" : new Intl.NumberFormat("en-AU", { style: "currency", currency: cur }).format(n);

export const fmtCents = (c, cur = "AUD") => (c == null ? "—" : fmtMoney(c / 100, cur));
export const fmtNumber = (n) => (n == null ? "—" : new Intl.NumberFormat("en-AU").format(n));

export function contrastText(hex) {
  const h = (hex || "#0D9488").replace("#", "");
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16) / 255);
  const lum = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return lum > 0.6 ? "#0F172A" : "#FFFFFF";
}

export const fullName = (c) => `${c?.first_name || ""} ${c?.last_name || ""}`.trim();
export const portalUrl = (slug) => `${window.location.origin}/g/${slug}`;
